import React from 'react';
import { useQcWithBatch, useUnitLookup } from '../graphql/queries';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import Typo from '../teal-react/components/atoms/Typo';
import Loading from '../teal-react/components/molecules/Loading';
import Utils from '../teal-react/utils';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useSave } from '../graphql/hooks';
import BatchMaterialEditor from './BatchMaterialEditor';

interface BatchEditorProps {
  qc_id: number;
  onCancel: () => void;
}

const BatchEditor = ({ qc_id, onCancel }: BatchEditorProps) => {
  const { data } = useQcWithBatch(qc_id);
  const saveQc = useSave('qc', 'qc');
  const { data: units } = useUnitLookup();
  if (!data || !units) {
    return <Loading />;
  }
  const qc = data.qc[0];

  return (
    <SimpleForm
      subheader="Batch Editor"
      cancel={onCancel}
      actionsLeft={[
        {
          label: 'Cancel',
          onClick: onCancel,
        },
      ]}
      model={qc}
      save={({ modified }: { modified: any }) => {
        saveQc({
          id: qc.id,
          ...modified,
        });
        onCancel();
      }}
      fields={[
        {
          size: 12,
          content: (
            <SimpleGrid
              spacing={1}
              items={[
                {
                  content: Typo.batch_header(
                    'Lot #',
                    qc.qc_code.split('-').slice(-1)[0]
                  ),
                  size: 6,
                },
                {
                  content: Typo.batch_header(
                    'Start Date',
                    Utils.date.formatDate(qc.date) || ''
                  ),
                  size: 6,
                },
                {
                  content: Typo.batch_header('Product #', qc.product.code),
                  size: 6,
                },
                {
                  content: Typo.batch_header('Product', qc.product.name),
                  size: 6,
                },
              ]}
            />
          ),
        },
        {
          header: 'QC Code',
          size: 6,
        },
        {
          header: 'Quantity',
          size: 6,
        },
        {
          name: 'qc_code',
          label: 'QC Code',
          size: 6,
          validate: { required: true },
        },
        {
          name: 'amount',
          label: 'Amount',
          size: 3,
          number: true,
          validate: { required: true },
        },
        {
          name: 'unit_id',
          label: 'Unit',
          size: 2,
          options: units.unit.map((u: any) => ({
            label: u.name,
            value: u.id,
          })),
          validate: { required: true },
        },
        {
          size: 12,
          content: <BatchMaterialEditor batch_id={qc.batch?.[0]?.id} />,
        },
      ]}
    />
  );
};

export default BatchEditor;
